module.exports = __webpack_public_path__ + "static/media/sf-test-2.417827b2.mp3";